import React, { useContext } from "react";

import { Button } from "@material-ui/core";
import { UserContext } from "../context/UserContext";
import "./Postbox.css";
import { Formik, Form, Field, ErrorMessage } from "formik";

function Postbox(props) {
  const { user } = useContext(UserContext);
  const initialValues = {
    body: "",
  };
  async function onSubmit(values, actions) {
    const url = `${process.env.REACT_APP_CONNECTION_URL}/createPost`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": `Bearer ${user.token}`,
        },
        body: JSON.stringify({ body: values.body, creatorId: user.user }),
      });
      actions.resetForm({});
      props.childUpdate();
    } catch (err) {
      console.log(err);
    }
  }

  function validate(values) {
    let errors = {};
    if (!values.body) {
      errors.body = "Required!";
    }
    return errors;
  }
  return (
    <div className="postbox">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        {(formik) => {
          return (
            <Form>
              <div className="input-area">
                <Field
                  as="textarea"
                  name="body"
                  id="body"
                  placeholder="post something!"
                />
              </div>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={
                  !(formik.isValid && formik.dirty) || formik.isSubmitting
                }
              >
                Submit
              </Button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default Postbox;
